import {
  Unifree,
  useMask,
  QRCodeScannerModal,
  Icon
} from '@yes.technology/react-toolkit'
import { useRef } from 'react'
import { defer } from 'lodash'
import useRedundantState from '../../hooks/useRedundantState'
import useIsOpen from 'modules/shared/hooks/useIsOpen'
import ActionButton from 'modules/shared/ActionButton'
import styled from 'styled-components'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: flex-end;
  grid-gap: 0.25rem;
`

function ActivityInputString({
  id,
  label,
  informational,
  required,
  value,
  onChange,
  helpText,
  statusClass,
  explanationText,
  formatMask,
  isFetchingBlueprints = false,
  disabled,
  enableQRCodeReader = false
}) {
  const { applyMask } = useMask()
  const { redundantValue, setRedundantValue } = useRedundantState({ value })
  const inputRef = useRef(null)

  const {
    isOpen: isQrCodeReaderOpened,
    close: onCloseQrCodeReader,
    open: onOpenQrCodeReader
  } = useIsOpen()

  const handleDataFieldChange = (rawValue) => {
    const formattedValue = formatMask
      ? applyMask(rawValue, formatMask)
      : rawValue

    setRedundantValue(formattedValue)
    onChange(formattedValue)
  }

  const onScanSuccess = (content) => {
    if (content) {
      handleDataFieldChange(content)

      defer(() => {
        inputRef.current?.focus?.()
      })
    }

    onCloseQrCodeReader()
  }

  return (
    <>
      {enableQRCodeReader && (
        <QRCodeScannerModal
          isOpen={isQrCodeReaderOpened}
          onClose={onCloseQrCodeReader}
          onScanSuccess={onScanSuccess}
        />
      )}
      <Container>
        <Unifree
          ref={inputRef}
          label={label}
          id={id}
          value={redundantValue}
          informational={informational}
          required={!!required}
          statusClass={informational ? 'default' : statusClass}
          onChange={handleDataFieldChange}
          placeholder={helpText || explanationText}
          aria-label={label}
          isLoadingBlueprints={isFetchingBlueprints}
          disabled={disabled}
        />
        {enableQRCodeReader && (
          <ActionButton
            onClick={() => onOpenQrCodeReader()}
            variant='secondary'
          >
            <Icon iconName='QRCodeReader' icSize='semiSmall' />
          </ActionButton>
        )}
      </Container>
    </>
  )
}

export default ActivityInputString
